export const assessmentData = [
  "Malaria",
  "VRTI",
  "PUD (Pelvic ulcer disease)",
  "Acute watery diarrhea",
  "Hypertenion",
  "Diabetes",
  "Asthma",
  "Truma",
  "STI",
  "PID",
  "VDC",
  "Urinary trait infection",
  "Emergency ulcer",
];
export const examinationData = [
  "General physical examination (GPE)",
  "Systemic examination (CNS)",
  "Systemic examination (Respiratory)",
  "Systemic examination (CVS)",
  "Systemic examination (Abdomen)",
  "Systemic examination (UGS)",
  "Systemic examination (Skin)",
  "Systemic examination (MSS)",
  "Systemic examination (Others)",
];
export const signsAndSymptomsData = [
  "Fever",
  "Headache",
  "Body aches",
  "Cough",
  "Catarrh",
  "Nausea",
  "Vomiting",
  "Stooling",
  "Dizziness",
  "Fainting",
  "Chest pain",
  "Smelling",
  "Abdominal panin",
  "Ear pains",
  "Ear discharge",
  "Eye pain",
  "Eye discharge",
  "Eye itching",
  "Redness of the eye",
  "Laceration",
  "Vaginal itching",
  "Vaginal discharge",
  "Dysuria",
  "Urinary frequency",
  "Hesitancy",
];
export const planData = ["Emergency"];
